import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { createTariffFailed, createTariffSuccessful } from '../actions';
import { CREATED, OK } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* createTariff(action) {
  try {
    const pool = action.payload;

    const url = `${BACKEND_URL}/proxy/tariff/v1/tariffs`;
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    if (dataResponse.status === CREATED || dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(createTariffSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      const data = yield dataResponse.json();
      yield put(createTariffFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createTariffFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
